module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-28.2ddec23e.png";